export default __webpack_public_path__ + "b2b9d74b409000880abc81c928f3fbf0.svg";